import { type Row, record, scalar, upper } from '../ability/context.js';

export interface OrbBoundary { actor_id: string; round: number; combat_id: string }
export function currentOrbBoundary(encounter: Row): OrbBoundary | null {
  const row = record(encounter.encounters) ?? encounter;
  const actor_id = upper(scalar(row.current_encounter_creature_id_turn));
  const combat_id = upper(scalar(row.active_combat_id));
  const round = Number(scalar(row.current_round));
  const uuid = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/;
  return Number(scalar(row.in_combat)) === 1 && String(scalar(row.turn_phase) ?? 'main') === 'main'
    && uuid.test(actor_id) && uuid.test(combat_id) && Number.isSafeInteger(round) && round >= 0 ? { actor_id, combat_id, round } : null;
}
/** Same deterministic identity in the served start, legacy observer and PHP receipt. */
export async function orbOperationId(kind: 'eot' | 'channel' | 'binding', boundary: OrbBoundary): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`orb-${kind}|${upper(boundary.combat_id)}|${boundary.round}|${upper(boundary.actor_id)}`));
  const h = [...new Uint8Array(digest)].map(n => n.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-4${h.slice(13, 16)}-8${h.slice(17, 20)}-${h.slice(20, 32)}`.toUpperCase();
}
export function orbBoundaryMatches(encounter: Row, boundary: OrbBoundary): boolean {
  const held = currentOrbBoundary(encounter);
  return !!held && held.actor_id === upper(boundary.actor_id) && held.combat_id === upper(boundary.combat_id) && held.round === boundary.round;
}
